import {type GameColor} from '../../GameColor.ts'
import {PIXI} from '@colonist/pixi'

export class UIGameToolTipBgView extends PIXI.Container {
    protected readonly w: number
    protected readonly h: number
    protected readonly backgroundColor: GameColor.Color
    private readonly cornerRadius: number

    constructor(container: PIXI.Container, w: number, h: number, cornerRadius: number, backgroundColor: GameColor.Color) {
        super()
        this.backgroundColor = backgroundColor
        this.w = w
        this.h = h
        this.cornerRadius = cornerRadius
        this.drawToolTipBg()
        container.addChildAt(this, 0)
    }

    private drawToolTipBg() {
        const bg = new PIXI.Graphics()
        bg.beginFill(this.backgroundColor)
        bg.drawRoundedRect(0, 0, this.w, this.h, this.cornerRadius)
        bg.endFill()
        this.addChild(bg)
    }
}
